import { CliError, CliErrorCode } from '@wix/cli-error';
import { getWixLockFilePath } from '@wix/cli-core-definitions';
import { pathExists, readFile, outputFile } from '@wix/cli-fs';

export function isWixLockExists(projectFolder: string) {
  return pathExists(getWixLockFilePath(projectFolder));
}

export function readWixLock(projectFolder: string) {
  return readFile(getWixLockFilePath(projectFolder), 'utf-8');
}

export async function saveWixLock(projectFolder: string, content: string) {
  try {
    await outputFile(getWixLockFilePath(projectFolder), content);
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.FailedToWriteWixLock(),
      cause: e,
    });
  }
}
